import React from "react";
import Container from "react-bootstrap/Container"
import Login2 from '../views/Login2'
import firebaseApp from "../firebase/credenciales";
import { getAuth, onAuthStateChanged, sendPasswordResetEmail } from "firebase/auth";
import Home_Produccion from "../views/Home_Produccion";
const auth = getAuth(firebaseApp);



function CRUD_Produccion({pagina, start, Pagina_principal}){
  
    const [usuario, setUsuario] = React.useState(null);

  onAuthStateChanged(auth, (usuarioFirebase) => {
    if (usuarioFirebase) {
      setUsuario(usuarioFirebase);
    } else {
      setUsuario(null);
    }
  });
    return(
      <div>
      {usuario ? <Home_Produccion usuario={usuario} pagina={pagina} start={start} Pagina_principal={Pagina_principal}></Home_Produccion>: <Login2 />}
      </div>
    
    );
}




export default CRUD_Produccion;